import React, { createContext, useContext, useEffect, useState } from "react";
import client, { formatApiError } from "@/api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    client.get("/auth/me")
      .then(res => setUser(res.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const res = await client.post("/auth/login", { email, password });
    setUser(res.data);
    return res.data;
  };

  const register = async (email, password, name) => {
    const res = await client.post("/auth/register", { email, password, name });
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    await client.post("/auth/logout");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
